import { render, staticRenderFns } from "./newHandleVip.vue?vue&type=template&id=1f384a62&scoped=true&"
import script from "./newHandleVip.vue?vue&type=script&lang=js&"
export * from "./newHandleVip.vue?vue&type=script&lang=js&"
import style0 from "./newHandleVip.vue?vue&type=style&index=0&id=1f384a62&scoped=true&lang=css&"
import style1 from "./newHandleVip.vue?vue&type=style&index=1&id=1f384a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f384a62",
  null
  
)

export default component.exports